<template>
  <svg class="icon-font" aria-hidden="true" :style="{ fontSize: size + 'px' }" v-on="$listeners">
    <use :xlink:href="`#${name}`"></use>
  </svg>
</template>
<script>
export default {
  name: 'icon-font',
  props: ['name', 'size'],
}
</script>
<style scoped>
.icon-font {
  fill: currentColor;
}
</style>
